import { inject, Service } from '@angular/core';
import { OTPChannelType } from 'src/app/shared/model/auth-channels';
import { ApiService } from 'src/app/shared/services/api.service';
import { LogToastService } from 'src/app/shared/services/log-toast/log-toast.service';

@Service({ autoProvided: false })
export class ForgotPasswordService {
  #api = inject(ApiService);
  #logToast = inject(LogToastService);

  resolveUsername(email: string | undefined, mobile: string | undefined): string | undefined {
    const normalizedEmail = email?.toLowerCase().trim();
    return normalizedEmail || mobile;
  }

  resolveChannelType(email: string | undefined, mobile: string | undefined): OTPChannelType | undefined {
    const normalizedEmail = email?.toLowerCase().trim();
    return normalizedEmail ? OTPChannelType.Email : mobile ? OTPChannelType.SMS : undefined;
  }

  async checkAccountExists(username: string): Promise<boolean> {
    try {
      const usernamePromise = this.#api.isUsernameAvailable(username);
      const emailPromise = this.#api.isEmailAvailable(username);
      const [usernameUnavailable, emailUnavailable] = await Promise.all([usernamePromise, emailPromise]);

      if (usernameUnavailable.available && emailUnavailable.available) {
        this.#logToast.error('MESSAGES.ERRORS.ENTER_VALID_EMAIL_OR_MOBILE', undefined, undefined, {
          logger: false,
          toast: true,
        });
        this.#logToast.error(
          'MESSAGES.ERRORS.ACCOUNT_USERNAME_DOES_NOT_EXIST',
          undefined,
          { username },
          { logger: false, toast: true },
        );
        return false;
      }
      return true;
    } catch (e) {
      this.#logToast.error('MESSAGES.ERRORS.FAILED_TO_SEND_OTP', e);
      return false;
    }
  }

  async resetPassword(
    id: string,
    address: string,
    channel: OTPChannelType,
    password: string,
    loginType: string,
  ): Promise<boolean> {
    try {
      await this.#api.forgotPassword({ id, address, channel, password });
      this.#logToast.success(
        'MESSAGES.SUCCESS.SUCCESSFULLY_UPDATE_LOGIN_TYPE',
        { loginType },
        { logger: false, toast: true },
      );
      return true;
    } catch (e) {
      this.#logToast.error('MESSAGES.ERRORS.FAILED_TO_RESET_PASSWORD', e);
      return false;
    }
  }
}
